<template>
    <div
        v-show="isReadyToShow"
        class="mpCombinations"
    >
        <Carousel
            v-bind:itemsToShow="1.1"
            v-bind:itemsToScroll="1"
            v-bind:mouseDrag="true"
            v-bind:wrapAround="false"
            name="slide-fade"
            class="mpCombinations-content"
            v-bind:class="{ multiple: isMultipleSlide }"
        >
            <Slide v-for="(combination, index) in visibleCombinations" v-bind:key="combination.key">
                <MpCombination
                    v-bind:combination="combination"
                    v-bind:order="index + 1"
                />
            </Slide>
        </Carousel>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import { Carousel, Slide } from 'vue3-carousel';
    import MpCombination from '@/components/recommendations/MpCombination.vue';
    import { useMpRecommendations } from '@/libraries/recommendation/useMpRecommendations';
    import { useResolvedMpCombinations } from '@/libraries/recommendation/useResolvedMpCombinations';

    const { popularMixParlays, isLoaded: isRecommendationsLoaded } = useMpRecommendations();

    const {
        visibleCombinations,
        hasCompletedInitialResolution,
    } = useResolvedMpCombinations(popularMixParlays);

    const isReadyToShow = computed(() => hasCompletedInitialResolution.value
        && isRecommendationsLoaded.value
        && visibleCombinations.value.length > 0);
    const isMultipleSlide = computed(() => visibleCombinations.value.length > 1);
</script>

<style lang="scss" scoped>
@import "vue3-carousel/dist/carousel.css";

.mpCombinations {
    margin: 1rem;

    .carousel {
        touch-action: pan-y;
    }

    .carousel__slide {
        align-items: stretch;
    }
}
</style>
